// @flow
import React, { useState } from 'react';
import IconInfostringOff from 'material-ui/svg-icons/social/notifications-off';
import IconInfostringNotAvailable from 'material-ui/svg-icons/alert/error-outline';
import IconInfostring from 'material-ui/svg-icons/social/notifications';
import IconInfostringHot from 'material-ui/svg-icons/social/notifications-active';
import { titleValidation } from '../../../util/validation';
import * as InfoStringEditMutation from "../../../mutations/InfoStringEditMutation";
import modernEnvironment from "../../../lib/RelayUtils";

const colorDefault = '#777';
const colorInfostring = 'blue';
const colorInfostringHot = 'red';
const colorInfostringTooLong = colorDefault;

export const ActionCell = (props: Object) => {
	const [state, setState] = useState({
		infostring: props.infostring,
		infostring_hot: props.infostring_hot,
	});

	const handleClick = (key: string) => (event) => {
		event.stopPropagation();
		const newValue = !state[key];
		const request = {
			...props,
			[key]: newValue
		}
		if (key === 'infostring' && !newValue) {
			request['infostring_hot'] = false;
		}
		if (key === 'infostring_hot' && newValue) {
			request['infostring'] = true;
		}
		InfoStringEditMutation.commit(modernEnvironment, request, (error: ?Error) => {
			if(!error) {
				setState({
					infostring: request.infostring,
					infostring_hot: request.infostring_hot,
				})
			}
		})
	};


	const incorrect = titleValidation(props.title);


	return (
		<div className="articles--icon">
			{!incorrect ? (
				<div className="articles--icon">
					<div title={'В бегущей строке'} className="articles--icon-item" onClick={handleClick('infostring')}>
						{state.infostring ? (
							<IconInfostring style={{ color: colorInfostring }} />
						) : (
							<IconInfostringOff style={{ color: colorDefault }} />
						)}
					</div>
					<div title={'В бегущей строке - Срочно!'} className="articles--icon-item" onClick={handleClick('infostring_hot')}>
						{state.infostring_hot ? (
							<IconInfostringHot style={{ color: colorInfostringHot }} />
						) : (
							<IconInfostringOff style={{ color: colorDefault }} />
						)}
					</div>
				</div>
			) : (
				<div className="articles--icon">
					<div title={'Заголовок слишком длинный'} className="articles--icon-item">
						<IconInfostringNotAvailable style={{ color: colorInfostringTooLong }} />
					</div>
					<div title={'Заголовок слишком длинный'} className="articles--icon-item">
						<IconInfostringNotAvailable style={{ color: colorInfostringTooLong }} />
					</div>
				</div>
			)}
		</div>
	);
};



// WEBPACK FOOTER //
// src/components/info-strings/columns/actions.js